/* eslint-disable no-control-regex */
/* eslint-disable no-undef */
/* eslint-disable no-func-assign */

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
    return call
  }
  return _assertThisInitialized(self)
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
  }
  return self
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o)
      }
  return _getPrototypeOf(o)
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function')
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true }
  })
  if (superClass) _setPrototypeOf(subClass, superClass)
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p
      return o
    }
  return _setPrototypeOf(o, p)
}

function _instanceof(left, right) {
  if (right != null && typeof Symbol !== 'undefined' && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left)
  } else {
    return left instanceof right
  }
}

function _typeof(obj) {
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj
    }
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
    }
  }
  return _typeof(obj)
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) {
    throw new TypeError('Cannot call a class as a function')
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i]
    descriptor.enumerable = descriptor.enumerable || false
    descriptor.configurable = true
    if ('value' in descriptor) descriptor.writable = true
    Object.defineProperty(target, descriptor.key, descriptor)
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps)
  if (staticProps) _defineProperties(Constructor, staticProps)
  return Constructor
}

var Dispatcher =
  /*#__PURE__*/
  (function () {
    function Dispatcher(options) {
      _classCallCheck(this, Dispatcher)

      this.events = {}
    }

    _createClass(Dispatcher, [
      {
        key: 'addListener',
        value: function addListener(event, callback) {
          // Check if the callback is not a function
          if (typeof callback !== 'function') {
            console.error('The listener callback must be a function, the given type is '.concat(_typeof(callback)))
            return false
          } // Check if the event is not a string

          if (typeof event !== 'string') {
            console.error('The event name must be a string, the given type is '.concat(_typeof(event)))
            return false
          }

          if (typeof this.channelName === 'string') {
            this.channelName = [this.channelName]
          }

          let channels = this.channelName
          channels.forEach(function (ch) {
            let eventChannel = event.concat('-', ch)

            // Create the event if not exists
            if (socketConfig.events[eventChannel] === undefined) {
              socketConfig.events[eventChannel] = {
                listeners: []
              }
            }

            socketConfig.events[eventChannel].listeners.push(callback)
          })
        }
      },
      {
        key: 'removeListener',
        value: function removeListener(event, callback) {
          // Check if this event not exists
          if (window.socketConfig.events[event] === undefined) {
            return false
          }

          window.socketConfig.events[event].listeners = window.socketConfig.events[event].listeners.filter(function (listener) {
            return listener.toString() !== callback.toString()
          })
        }
      },
      {
        key: 'dispatch',
        value: function dispatch(event, details) {
          // Check if this event not exists
          if (socketConfig.events[event] === undefined) {
            return false
          }

          socketConfig.events[event].listeners.forEach(function (listener) {
            listener(details)
          })
        }
      }
    ])

    return Dispatcher
  })()

if (typeof window.socketGlobal == 'undefined') {
  global.socketConfig = {
    url: '',
    timeoutKeepAlive: 90000,
    timeId: 0,
    events: [],
    connecting: false
  }
  global.socketGlobal = {}

  global.keepAlive = function () {
    if (socketGlobal.readyState == socketGlobal.OPEN) {
      socketGlobal.send({
        message: 'pingConnection',
        data: ''
      })
    }

    socketConfig.timeId = setTimeout(keepAlive, socketConfig.timeoutKeepAlive)
  }

  global.cancelKeepAlive = function () {
    if (socketConfig.timeId) {
      clearTimeout(socketConfig.timeId)
    }
  }
} else {
  global.existGlobalSocket = true
}

var SocketClient =
  /*#__PURE__*/
  (function (_Dispatcher) {
    _inherits(SocketClient, _Dispatcher)

    function SocketClient(options) {
      var _this

      _classCallCheck(this, SocketClient)

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SocketClient).call(this, options))

      if (typeof options.socketDomain == 'undefined') {
        console.log('The socket domain not found')
        return _possibleConstructorReturn(_this)
      }
      socketConfig.domain = options.socketDomain
      _this.subscribeKey = options.subscribeKey

      if (typeof existGlobalSocket == 'undefined' || (typeof socketConfig != 'undefined' && !socketConfig.connecting)) {
        _this.connect()
      }

      return _this
    }

    _createClass(SocketClient, [
      {
        key: 'connect',
        value: async function connect() {
          // if user is running mozilla then use it's built-in WebSocket
          window.WebSocket = window.WebSocket || window.MozWebSocket // if browser doesn't support WebSocket, just show some notification and exit

          if (!window.WebSocket) {
            console.log("The browser doesn't support WebSockets.")
            return
          } // open connection

          try {
            socketGlobal = await new WebSocket('wss://' + socketConfig.domain + '?subscribeKey=' + this.subscribeKey)
          } catch (e) {
            console.log(e)
            return
          }

          var self = this

          socketGlobal.onopen = function () {
            if (socketGlobal.readyState == socketGlobal.OPEN) {
              socketConfig.connecting = true
              self.send({ subscribeChannels: self.channelName })
              keepAlive()
            }
          }

          socketGlobal.onclose = function (event) {
            if (socketConfig.timeId != 0) {
              cancelKeepAlive()
              window.setTimeout(() => self.connect(), 5000)
            }
          }

          socketGlobal.onerror = function (error) {
            console.log("There's some problem with your connection or the server is down.")
            return
          } // most important part - incoming messages

          socketGlobal.onmessage = function (message) {
            try {
              var json = JSON.parse(message.data)
              if (message.type === 'message' && json.message !== 'Forbidden') {
                var ev = message.type.concat('-', json.channel)
                self.dispatch(ev, json)
              }
            } catch (e) {
              console.log(e)
            }
          } // most important part - incoming messages

          socketGlobal.onhistory = function (message) {
            try {
              var json = JSON.parse(message.data)
              if (message.type === 'message' && json.message !== 'Forbidden') {
                self.dispatch('message', json)
              }
            } catch (e) {
              console.log(e)
            }
          }
        }
      },
      {
        key: 'subscribe',
        value: function subscribe(channel) {
          var self = this
          self.channelName = channel.channels
          if (socketConfig.connecting) {
            self.send({ subscribeChannels: self.channelName })
          }
        }
      },
      {
        key: 'history',
        value: function history(options) {
          if (typeof options.socketApi == 'undefined') {
            return
          }

          options.subscribeKey = this.subscribeKey
          var msg = JSON.stringify(options)
          msg = this.addslashes(msg)
          var xmlhttp
          xmlhttp = new XMLHttpRequest()
          var self = this

          xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
              var json = JSON.parse(xmlhttp.responseText)

              if (json == null) {
                return
              }

              if (typeof json[0] != 'undefined') {
                json = JSON.parse(json[0])
              }
              var ev = 'history'
              ev = ev.concat('-', json.channel)
              self.dispatch(ev, json)
            }
          }

          var url = 'https://' + options.socketApi + '/get-messages'
          xmlhttp.open('POST', url, true)
          xmlhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
          delete options.socketApi
          var data = JSON.stringify({
            data: options
          })
          xmlhttp.send(data)
        }
      },
      {
        key: 'addslashes',
        value: function addslashes(string) {
          return string
            .replace(/\\/g, '\\\\')
            .replace(/\u0008/g, '\\b')
            .replace(/\t/g, '\\t')
            .replace(/\n/g, '\\n')
            .replace(/\f/g, '\\f')
            .replace(/\r/g, '\\r')
            .replace(/'/g, "\\'")
            .replace(/"/g, '\\"')
        }
      },
      {
        key: 'send',
        value: function send(data) {
          socketGlobal.send(
            JSON.stringify({
              message: 'sendMessage',
              data: JSON.stringify(data)
            })
          )
        }
      }
    ])

    return SocketClient
  })(Dispatcher)

export default SocketClient
